import { 
	SET_FIRST_LOAD_COUNTER,
	SET_FIRST_LOAD_LIST,
	SET_ALERT_COUNTER,
	SET_ALERT_LIST,
	SET_ISPANEL_NOTIFICATION_OPEN,
	SET_ALERT_SEARCH_IDENTIFIERS,
	SET_ALERT_DIALOG_TITLE
} from "../actions/SITE/actions";

const initialState = {
	_firsLoadCounter: false,
	_firsLoadList: false,
	_alertCounter: null,
	_alerDialogTitle: null,
	_alertList: null,

	_alertSearchIdentifiers: {
		rootId: null,
		itemId: null
	},

	_isPanelNotificationAlertOpen: false
};

const notificationAlertReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_FIRST_LOAD_COUNTER:
			return {
				...state,
				_firsLoadCounter: action.payload
			};
		case SET_FIRST_LOAD_LIST:
			return {
				...state,
				_firsLoadList: action.payload
			};

		case SET_ISPANEL_NOTIFICATION_OPEN:
			return {
				...state,
				_isPanelNotificationAlertOpen: action.payload
			};




		case SET_ALERT_DIALOG_TITLE:
			return {
				...state,
				_alerDialogTitle: action.payload
			};
		case SET_ALERT_COUNTER:
			return {
				...state,
				_alertCounter: action.payload
			};
		case SET_ALERT_LIST:
			return {
				...state,
				_alertList: action.payload
			};

		case SET_ALERT_SEARCH_IDENTIFIERS:
			return {
				...state,
				_alertSearchIdentifiers: action.payload
			};
		default:
			return state;
	}
};



export default notificationAlertReducer;